import React from "react";
import Wavify from "react-wavify";
import logo from "../saws_logo_with_title.png"; // The logo image
import { Link } from "react-router-dom";

const Intro: React.FC = () => {
  return (
    <div className="intro-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100vh',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: 'white'
    }}>
      {/* Main content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        width: '100%',
        padding: '0 20px',
        marginTop: '40px'
      }}>
        {/* Logo with text */}
        <img 
          src={logo} 
          alt="SAWS Logo" 
          style={{ 
            width: 'auto',
            maxWidth: '100%',
            maxHeight: '60%',
            marginBottom: '40px'
          }} 
        />

        {/* Buttons Container */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          width: '220px',
          alignItems: 'center'
        }}>
          {/* Launch Tool button */}
          <Link 
            to="/tools/explorer" 
            style={{
              backgroundColor: '#1A5387',
              color: 'white',
              width: '100%',
              padding: '10px',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '15px',
              fontWeight: '400',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              transition: 'background-color 0.2s ease, transform 0.1s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1976d2';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#1A5387';
            }}
          >
            Launch the Tool
          </Link>

          {/* Learn More text link */}
          <Link 
            to="/learn-more" 
            style={{
              color: 'gray',
              width: '100%',
              textAlign: 'center',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '400',
              marginTop: '5px',
              transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = '#2c7ac3';
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = 'gray';
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            or Learn More
          </Link>
        </div>
      </div>

      {/* Wave container at the bottom */}
      <div style={{
        position: 'relative',
        width: '100%',
        height: '250px', /* Fixed height for the waves section */
        marginTop: 'auto'
      }}>
        {/* Lexunit attribution - positioned within the bottom wave */}
        <div style={{
          position: 'absolute',
          bottom: '0px',
          left: '0',
          right: '0',
          zIndex: 10,
          textAlign: 'right',
          padding: '10px',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          fontSize: '14px',
          color: 'rgba(255, 255, 255, 0.8)',
          textShadow: '0 1px 2px rgba(0,0,0,0.2)',
          pointerEvents: 'none' // Ensures the div doesn't interfere with clicks
        }}>
          Created by{' '}
          <a 
            href="https://lexunit.ai/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: '500',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              display: 'inline-block',
              pointerEvents: 'auto' // Re-enables clicks just for the link
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = '#ffffff';
              e.currentTarget.style.textShadow = '0 0 8px rgba(255,255,255,0.6)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
              e.currentTarget.style.textShadow = '0 1px 2px rgba(0,0,0,0.2)';
            }}
          >
            Lexunit
          </a>
        </div>

        {/* Waves */}
        <Wavify
          style={{
            position: 'absolute',
            bottom: '25px',
            width: '100%'
          }}
          fill="#78a5c5"
          options={{
            height: 20,
            amplitude: 25,
            speed: 0.15,
            points: 3
          }}
        />
        <Wavify
          style={{
            position: 'absolute',
            bottom: '15px',
            width: '100%'
          }}
          fill="#0f5387"
          options={{
            height: 40,
            amplitude: 30,
            speed: 0.2,
            points: 4
          }}
        />
        <Wavify
          style={{
            position: 'absolute',
            bottom: '-5px',
            width: '100%'
          }}
          fill="#09366e"
          options={{
            height: 60,
            amplitude: 40,
            speed: 0.15,
            points: 5
          }}
        />
      </div>
    </div>
  );
};

export default Intro;